import { computed, ref } from 'vue'

import { serverErrorMessage } from '@/shared/api'
import { message } from '@/shared/lib'

import { useAccount } from '@/apps/adok/entities/account'

export function useAcceptTerms() {
  const { accountId, isStaff, termsAccepted, acceptTerms } = useAccount()

  const submitting = ref(false)

  // Staff acceptance would be recorded against the publisher with the support seat's IP.
  const open = computed(
    () => accountId.value > 0 && !isStaff.value && !termsAccepted.value
  )

  async function accept() {
    if (!open.value || submitting.value) return

    submitting.value = true

    try {
      await acceptTerms()
    } catch (error) {
      message.error(
        serverErrorMessage(error, 'Could not record your acceptance.')
      )
    } finally {
      submitting.value = false
    }
  }

  return { open, submitting, accept }
}
